import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyDatePickerModule } from 'mydatepicker';
import { AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { SignaturePadModule } from 'angular2-signaturepad';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { ClearingHouseComponent } from './clearing-house.component';
import { ClearingHouseRoutingModule } from './clearing-house-routing.module';
import { ClearingHouseService } from './clearing-house.service';
import { GetHTTPService } from './clearing-housing-table.service';

@NgModule({
  declarations: [
    ClearingHouseComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    GridModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    PdfViewerModule,
    NgSelectModule,
    ClearingHouseRoutingModule,
    MyDatePickerModule,
    AccordionModule,
    SignaturePadModule,
  ],
  exports: [ClearingHouseComponent],
  providers: [ClearingHouseService, ColumnChooserService, PageService, SortService, FilterService, ResizeService, GetHTTPService],
})

export class ClearingHouseModule { }
